export default __webpack_public_path__ + "static/media/formato.06191a14.png";